import compact from 'lodash/compact';
import uniq from 'lodash/uniq';

import type { PracticeContactViewModel } from 'chaika-types';

export function collectPracticeClinicIds(practices: PracticeContactViewModel[]): string[] {
    return uniq(compact(practices.map(({ organizationId }) => organizationId)));
}
